import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
import { computed } from 'vue';
import { useStore } from 'vuex';
import { storeToRefs } from 'pinia';
import { useRetroStore } from '@/pinia_stores/retro';
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ActionItemOwnerAvatars',
    props: {
        item: null,
        editable: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const retroStore = useRetroStore();
        const { users } = storeToRefs(retroStore);
        const { unassignCurrentUserFromActionItem } = retroStore;
        const sessionId = computed(() => store.getters.session.id);
        const hasOwners = computed(() => props.item.owners?.length > 0);
        function handleUnassign() {
            unassignCurrentUserFromActionItem(props.item.id);
        }
        return (_ctx, _cache) => {
            const _component_avatar = _resolveComponent("avatar");
            return (_unref(hasOwners))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.owners, (owner) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: owner.userId,
                            class: "relative mb-1"
                        }, [
                            _createVNode(_component_avatar, {
                                user: _unref(users).find((user) => user.id === owner.userId)
                            }, null, 8, ["user"]),
                            (__props.editable && _unref(sessionId) === owner.userId)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "absolute top-0 right-0 hidden -mt-1 -mr-1 group-hover:block",
                                    onClick: handleUnassign
                                }, [
                                    _createVNode(SvgIcon, {
                                        name: "x",
                                        class: "w-5 h-5"
                                    })
                                ]))
                                : _createCommentVNode("", true)
                        ]));
                    }), 128))
                ]))
                : (_openBlock(), _createBlock(_component_avatar, {
                    key: 1,
                    user: null
                }));
        };
    }
});
